export interface SkillDef {
  id: string;
  name: string;
  description: string;
}

export const SKILL_DEFS: SkillDef[] = [
  { id: 'fishing', name: 'Fishing', description: '+7% catch weight and +4.2% catch speed at Lv.2, diminishing returns per level' },
  { id: 'bartering', name: 'Bartering', description: '+4.2% sell price at Lv.2, diminishing returns per level' },
  { id: 'business', name: 'Business', description: '+7% vessel trip profit at Lv.2, +1 vessel cap every 10 levels, diminishing returns per level' },
  { id: 'luck', name: 'Luck', description: '+5.6% rare fish chance at Lv.2, diminishing returns per level' },
];

export function getSkillDefById(id: string): SkillDef | undefined {
  return SKILL_DEFS.find(s => s.id === id);
}

export function getPlayerXpToNextLevel(level: number): number {
  return Math.max(1, Math.floor(100 * Math.pow(Math.max(1, level), 1.7)));
}

export function calcBonus(level: number, baseMultiplier: number): number {
  return 1 + baseMultiplier * Math.pow(Math.max(0, level - 1), 0.6);
}

export function addXpToPlayer(
  level: number,
  xp: number,
  xpToNext: number,
  amount: number
): { level: number; xp: number; xpToNext: number; leveledUp: boolean } {
  let newLevel = level;
  let newXp = xp + amount;
  let newXpToNext = xpToNext;
  let leveledUp = false;

  while (newXp >= newXpToNext) {
    newXp -= newXpToNext;
    newLevel++;
    newXpToNext = getPlayerXpToNextLevel(newLevel);
    leveledUp = true;
  }

  return { level: newLevel, xp: newXp, xpToNext: newXpToNext, leveledUp };
}
